import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Button, Paper } from 'components'
import { DateSelector, TimeSelector } from 'features'
import { FaAngleDoubleRight } from 'react-icons/fa'

import * as actionCreators from 'store/actions'
import classes from './ScheduleInput.module.css'
import moment from 'moment-timezone';

const defaultStyle = {
    backgroundColor: 'var(--secondary-color)',
    padding: '1rem',
    width: 'auto',
    // border: '1px solid var(--primary-accent-color)'
}

const inlineStyle = {
    backgroundColor: 'var(--secondary-color)',
    padding: '0 0.5rem',
    width: 'auto',
    border: null
}

const Container = styled.div`
    border-radius: 5px;
    background-color: ${props => props.style.backgroundColor};
    padding: ${props => props.style.padding};
    width: ${props => props.style.width};
    border: ${props => props.style.border};
    
`

// const Title = styled.div`
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     margin-bottom: 0.5rem;
//     font-weight: bolder;
//     font-size: 0.9rem;
// `

const Title = styled.div`
    font-weight: bolder;
    font-size: 0.7rem;
    padding: 0.25rem 0 0.5rem 0.25rem;
    text-transform: uppercase;
    color: var(--secondary-accent-color);
`

const Wrapper = styled.div`
    box-sizing: border-box;
    padding: 0.5rem 1rem;
    /* width: ${props => `${props.width}px` || 'max-content'}; */
    justify-self: center;
`

class ScheduleInput extends Component {
    constructor(props){
        super(props);
        const timezone = this.props.user && this.props.user['timezone']
        this.startRef = React.createRef();
        this.endRef = React.createRef()
        this.state = {
            startDate: this.props.schedule.start_date || moment().tz(timezone),
            endDate: this.props.schedule.end_date || moment().tz(timezone),
            startTime: this.props.schedule.start_time && this.props.schedule.start_time.tz(timezone),
            endTime: this.props.schedule.end_time && this.props.schedule.end_time.tz(timezone)
        }

        this.style = Object.assign({}, this.props.inline ? inlineStyle : defaultStyle, this.props.style)
        this.timeButtonStyle = {
            backgroundColor:'var(--primary-color)',
            margin: 0,
            boxShadowColor: 'transparent',
            justifyContent: 'flex-start',
            padding: '0.2rem'
        }
    }

    selectDate = (dates) => {
        this.setState({
            startDate: dates[0],
            endDate: !dates[1] ? dates[0] : dates[1]
        })
    }

    selectTime = (time, type) => {
        if(type === 'start'){
            // Validation
            if(this.state.startDate && this.state.endTime && time && this.state.startDate.format() === this.state.endDate.format()){
                if(time.isBefore(this.state.endTime)){
                    this.setState({startTime: time})
                }
            } else {
                this.setState({startTime: time})
            }
        } else if (type === 'end'){
            // Validation
            if(this.state.endDate && this.state.startTime && time && this.state.startDate.format() === this.state.endDate.format()){
                if(time.isAfter(this.state.startTime)){
                    this.setState({endTime: time})
                }
            } else {
                this.setState({endTime: time})
            }
        }
    }

    resetHandler = () => {
        this.setState({
            startDate: null,
            endDate: null,
            startTime: null,
            endTime: null
        }, () => {
            this.props.onSubmit(this.state)
            this.props.closeHandler && this.props.closeHandler()
        })
    }

    cleanDates = (dates) => {
        // let dates = {...this.state}
        // Reset time
        // dates['startDate'] && dates['startDate'].set({hour: 0, minute: 0, second: 0})
        // dates['endDate'] && dates['endDate'].set({hour: 0, minute: 0, second: 0})

        // // Match date
        // dates['startTime'] && dates['startTime'].set({year: dates['startDate'].year(), month: dates['startDate'].month(), date: dates['startDate'].date()})
        // dates['endTime'] && dates['endTime'].set({year: dates['endTime'].year(), month: dates['endTime'].month(), date: dates['endTime'].date()})

        ['startDate','startTime','endDate','endTime'].map(schedule => {
            // Reset time
            if(['startDate','endDate'].includes(schedule)){
                if(dates[schedule]){
                    dates[schedule].set({hour: 0, minute: 0, second: 0})
                    dates[schedule] = dates[schedule].toISOString()
                } 
            } 
            
            // Match date
            else if (['startTime','endTime'].includes(schedule)){
                if(dates[schedule]){
                    const ref = schedule === 'startTime' ? 'startDate' : 'endDate'
                    const refDate = moment.isMoment(dates[ref]) ? dates[ref] : moment(new Date(dates[ref]))
                    dates[schedule].set({year: refDate.year(), month: refDate.month(), date: refDate.date()})
                    dates[schedule] = dates[schedule].toISOString()
                }
            }
        })

        return dates
    }

    submitHandler = () => {
        const updatedDates = this.cleanDates({...this.state})
        this.props.onSubmit(updatedDates)
        this.props.closeHandler && this.props.closeHandler()
    }

    render() {
        const content = 
        <Container style={this.style}>
            {!this.props.inline ? <Title>Schedule</Title> : null}

            <div className={classes.Content}>
                <Wrapper justifySelf='flex-end' ref={this.startRef} width={this.state.width}>
                    <div className={classes.Label}>Start</div>
                    <div className={classes.Title}>{this.state.startDate ? this.state.startDate.format('ddd D') : 'Add date'}</div>
                    <Button placement='bottom' styles={this.timeButtonStyle}
                        text={this.state.startTime ? this.state.startTime.format('h:mm a') : '+ Add time'}
                        contextMenu={<TimeSelector value={this.state.startTime} 
                            onSelect={(time) => this.selectTime(time, 'start')} 
                            onClose={this.props.closeHandler}
                            filter={this.state.endTime ? {time: this.state.endTime, how:'after'} : null}
                            />}
                    />
                </Wrapper>

                <div className={classes.Arrow}><FaAngleDoubleRight/></div>

                <Wrapper justifySelf='flex-start' ref={this.endRef} width={this.state.width}>
                    <div className={classes.Label}>End</div>
                    <div className={classes.Title}>{this.state.endDate ? this.state.endDate.format('ddd D') : 'Add date'}</div>
                    <Button placement='bottom' styles={this.timeButtonStyle}
                        text={this.state.endTime ? this.state.endTime.format('h:mm a') : '+ Add time'}
                        contextMenu={<TimeSelector value={this.state.endTime} onSelect={(time) => this.selectTime(time, 'end')} 
                        filter={this.state.startTime ? {time: this.state.startTime, how:'before'} : null}
                        />}
                    />
                </Wrapper>
            </div>
            
            {/* Date selector */}
            <DateSelector type='dateRange' startDate={this.state.startDate} endDate={this.state.endDate} onSelect={this.selectDate}/>

            {/* Buttons */}
            <div className={classes.ButtonsContainer}>
                <Button text='Clear' styles={{backgroundColor:'var(--secondary-color)', boxShadowColor: 'transparent',fontWeight: 'bolder'}} onSelect={this.resetHandler}/>
                <Button text='Apply' styles={{backgroundColor:'var(--focus-color)', fontWeight: 'bolder', color: 'white'}} bold onSelect={this.submitHandler}/>
            </div>
        </Container>
        if(this.props.inline){
            return (<div>{content}</div>)
        } else {
            return (<Paper margin='0.5rem 0'>{content}</Paper>)
        }
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        inputID: state.content.inputID,
        user: state.auth.user
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setInput: (inputID) => dispatch(actionCreators.setInput(inputID)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleInput);

ScheduleInput.propTypes = {
    // start_date: PropTypes.instanceOf(Date),
    // end_date: PropTypes.instanceOf(Date),
    // start_time: PropTypes.instanceOf(Date),
    // end_time: PropTypes.instanceOf(Date),
    onSubmit: PropTypes.func.isRequired,
    inline: PropTypes.bool
}